import { render, staticRenderFns } from "./editCoupon.vue?vue&type=template&id=5a39c632&scoped=true&"
import script from "./editCoupon.vue?vue&type=script&lang=js&"
export * from "./editCoupon.vue?vue&type=script&lang=js&"
import style0 from "./editCoupon.vue?vue&type=style&index=0&id=5a39c632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a39c632",
  null
  
)

export default component.exports